/** Default subtask duration (minutes) when creating from the task form. */
export const TASK_FORM_DEFAULT_SUBTASK_DURATION_MINS = 15;

/** Radix for random pending-subtask local id suffix. */
export const TASK_FORM_PENDING_ID_RADIX = 16;

/** Vertical gap between form sections when the title lives in the modal header. */
export const TASK_FORM_HEADER_GAP = 1.5;
